module.exports = __webpack_public_path__ + "static/media/mujer-hombre6.bdbbe665.jpg";